export default __webpack_public_path__ + "static/media/kitchen4-afterC.96332853.jpg";